import { render, staticRenderFns } from "./addFullReduction.vue?vue&type=template&id=233c5a42&scoped=true"
import script from "./addFullReduction.vue?vue&type=script&lang=js"
export * from "./addFullReduction.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./addFullReduction.vue?vue&type=style&index=1&id=233c5a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233c5a42",
  null
  
)

export default component.exports